import React from "react";
import { FormControl, ControlLabel } from "react-bootstrap";
import ajax from "../../lib/ajax.js";
import context from "../../lib/context.js";
import ReactDOM from 'react-dom';

export default class IndustryCategory extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: []
        };

        this.loadCategories = this.loadCategories.bind(this);
        this.onChange = this.onChange.bind(this);
    }    

    componentDidMount() {
        this.loadCategories();
    }

    loadCategories() {
        let self = this;
        ajax.api().get("get-industry-categories")
            .then(function (res) {
                self.setState({ categories: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onChange(event) {
        var category = '';
        var selectedCategory = this.state.categories.filter(x => x.categoryId == event.target.value);

        if (selectedCategory.length > 0) {
            category = selectedCategory[0].category;
        }

        if (this.props.onChange)
            this.props.onChange(event.target.value, category, this.props.id);
    }

    render() {
        var categories = [];
        var allText = '';
        var readOnly = false;
        
        if (this.props.allText !== undefined)
            allText = this.props.allText;

        if (this.props.readOnly !== undefined)
            readOnly = this.props.readOnly;

        categories.push(<option key="" value="" selected="true">{allText}</option>);
        
        const self = this;
        var category = '';

        this.state.categories.map(function (item, i) {
            categories.push(<option key={item.categoryId} value={item.categoryId}>{item.category}</option>)

            if (item.categoryId == self.props.value)
                category = item.category;
        }, this);

        return (   
            <div className="ap-report-control-dropdown">     
            {
                readOnly == false ?
                    <FormControl
                        id={this.props.id + '-select'}
                        componentClass="select"
                        value={this.props.value}
                        onChange={this.onChange}
                        className={this.props.className}
                        readOnly={this.props.readOnly}>
                        {categories}
                    </FormControl> :
                    <div><ControlLabel className="ap-report-control-label ap-black-color">{category}</ControlLabel></div>
            }  
            </div>
        );
    }
}